import { Article, P } from '@slal/ui/typography';
import { uniqueId } from 'lodash';
import { StyledTitle, StyledValue, StyledValueSummary, ValueLoading } from './styles';
import { ValueSummaryProps } from './types';

export const ValueSummary = ({ title, value, summary, loading, ...otherProps }: ValueSummaryProps) => {
    const id = uniqueId(`value-summary-`);

    return (
        <StyledValueSummary {...otherProps} aria-labelledby={id}>
            <Article>
                <StyledTitle level={4} id={id}>
                    {title}
                </StyledTitle>
                {loading ? <ValueLoading width="50%" /> : <StyledValue weight="bold">{value}</StyledValue>}
                <P>{summary}</P>
            </Article>
        </StyledValueSummary>
    );
};
